import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PrimeNGConfig } from "primeng/api";
import { RippleModule } from "primeng/ripple";

@Component({
  selector: "app-button",
  standalone: true,
  imports: [RippleModule, NgClass],
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
})
export class ButtonComponent {
  @Input() disabled: boolean = false;
  @Input() icon: string = "";
  @Input() iconPos: "left" | "right" = "left";
  @Input() label: string = "";
  @Input() outlined: boolean = false;
  @Input() severity: "primary" | "secondary" | "success" | "info" | "warning" | "danger" | "transparent" = "primary";
  @Input() text: boolean = false;

  @Output() click: EventEmitter<void> = new EventEmitter<void>();

  constructor(private primeNgConfig: PrimeNGConfig) {
    this.primeNgConfig.ripple = true;
  }

  get buttonClasses(): string[] {
    const classes = ["custom-btn"];

    if (this.disabled) {
      classes.push("custom-btn--disabled");
      if (this.outlined) {
        classes.push("custom-btn--disabled-outlined");
      }
    } else {
      if (this.severity) {
        classes.push(`custom-btn--${this.severity}`);
        if (this.outlined) {
          classes.push(`custom-btn--${this.severity}-outlined`);
        }
      }
      if (this.text) {
        classes.push("custom-btn--text");
      }
    }

    return classes;
  }

  handleClick(event: Event): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.click.emit();
    }
  }
}
